import { PlayCircle } from 'lucide-react';
import { getTeamColor } from '@utils/cssVariables';
import './StartingPositionIcon.css';

/**
 * Shows where a unit started before its movement actions
 * Similar to the cinematic artificial starting icon but smaller and positioned on the map
 */
export default function StartingPositionIcon({ x, y, teamClass = 'enemy' }) {
  if (x === undefined || y === undefined) {
    console.warn("[StartingPositionIcon] Missing x,y coordinates:", { x, y });
    return null;
  }

  const teamColor = getTeamColor(teamClass);
  
  return (
    <div className={`starting-position-icon team-${teamClass}`}>
      <PlayCircle size={24} color={teamColor} fill="none" />
    </div>
  );
}